// import React from 'react';
// import certificate1 from './../Assets/certificate1.png'
// import certificate2 from './../Assets/certificate2.png'
// import certificate3 from './../Assets/certificate3.png'
// import './ServicesContent.css';

// const ServicesContent = () => {
//   return (
//     <div>
//       <div className="container mx-auto w-[90%] lg:w-[85%] md:w-[85%] sm:w-[85%] mt-10">
//         {/* Certifications Section */}
//         <section className="certifications-section my-10">
//           <h2 className="text-2xl font-bold text-blue-600 mb-4">Certifications</h2>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 md:grid-cols-3 gap-6 ">
//             <div className="certification-item">
//               <img
//                 src={certificate1}
//                 alt="Certificate 1"
//                 className="w-full h-auto object-cover"
//               />
//             </div>
//             <div className="certification-item">
//               <img
//                 src={certificate2}
//                 alt="Certificate 2"
//                 className="w-full h-auto object-cover"
//               />
//             </div>
//             <div className="certification-item">
//               <img
//                 src={certificate3}
//                 alt="Certificate 3"
//                 className="w-full h-auto object-cover"
//               />
//             </div>
//           </div>
//         </section>

//         {/* Global Export Projects & Services */}
//         <section className="projects-section my-10">
//           <h2 className="text-2xl font-bold text-blue-600 mb-4">Global Export Projects & Services</h2>
//           <ul className="project-list text-gray-700">
//             <li className="mb-2">Czech Republic – US Welding SPM (MATE, Prague)</li>
//             <li className="mb-2">Italy – US Welding SPM, Leak Testing SPM (Denso, Avelino)</li>
//             <li className="mb-2">South Africa – US Welding SPM, Post Process SPM, EOL Testing SPM (MSSL-RSA)</li>
//             <li className="mb-2">UAE - Aerospace Equipment (STRATA, Al-Ain)</li>
//             <li className="mb-2">USA – Consumer Product (AKA Bedside Butler, Washington-USA)</li>
//             <li>Thailand – Lift Assist Manipulator (Lear Corporation, Rayong)</li>
//           </ul>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default ServicesContent;

import React from 'react';

import certificate1 from './../Assets/certificate1.jpg';
import certificate2 from './../Assets/certificate2.jpg';
import certificate3 from './../Assets/certificate3.jpg';

import automationimage1 from './../Assets/image2.jpg';
import automationimage2 from './../Assets/automationimage2.jpg';

import roboticsimage1 from './../Assets/image1.jpg';
import roboticsimage2 from './../Assets/roboticsimage2.jpg';

import erimage1 from './../Assets/erimage1.jpg';
import erimage2 from './../Assets/erimage2.jpg';

import fximage1 from './../Assets/fximage1.jpg';
import fximage2 from './../Assets/fximage2.jpg';

import './ServicesContent.css';

const ServicesContent = () => {
  return (
    <div className="relative -z-10 container mx-auto w-[90%] lg:w-[85%] mt-20 mb-16">

      {/* Automation Section */}
      <section className="service-section">
        <h2 className="service-title">Automation</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          <div className="service-card">
            <img src={automationimage1} alt="22B RAP CAB BOX POST PROCESS SPM" />
            <h3 className="card-title">22B RAP CAB BOX POST PROCESS SPM</h3>
            <p className="card-text">
              A complete automation solution designed for high-precision punching applications,
              driving productivity and quality.
            </p>
          </div>
          <div className="service-card">
            <img src={automationimage2} alt="Automatic Connector Assembly & Testing SPM" />
            <h3 className="card-title">Automatic Connector Assembly & Testing SPM</h3>
            <p className="card-text">
              Fully automated assembly and testing solution with unmatched precision and efficiency
              for electrical connectors.
            </p>
          </div>
        </div>
      </section>

      {/* Robotic Cell Section */}
      <section className="service-section">
        <h2 className="service-title">Robotic Cell</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          <div className="service-card">
            <img src={roboticsimage1} alt="FCA - Front / Rear Bumper Ultrasonic Welding SPM" />
            <h3 className="card-title">FCA - Front / Rear Bumper Ultrasonic Welding SPM</h3>
            <p className="card-text">
              Precision ultrasonic welding solution for front and rear bumpers designed for
              high-volume automotive manufacturing.
            </p>
          </div>
          <div className="service-card">
            <img src={roboticsimage2} alt="Robotic Ultrasonic Welding Cell" />
            <h3 className="card-title">Robotic Ultrasonic Welding Cell</h3>
            <p className="card-text">
              Advanced automation for precision welding of complex automotive components using
              robotic technology.
            </p>
          </div>
        </div>
      </section>

      {/* Ergonomic Lift Assist Section */}
      <section className="service-section">
        <h2 className="service-title">Ergonomic Lift Assist</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          <div className="service-card">
            <img src={erimage1} alt="Beam Member Handling Manipulator" />
            <h3 className="card-title">Beam Member Handling Manipulator</h3>
            <p className="card-text">
              Advanced material handling solution for heavy beam members, enhancing safety and
              efficiency in manufacturing.
            </p>
          </div>
          <div className="service-card">
            <img src={erimage2} alt="Seat Handling Zero Gravity Manipulator" />
            <h3 className="card-title">Seat Handling Zero Gravity Manipulator</h3>
            <p className="card-text">
              Innovative solution for effortless handling of automotive seats during assembly and
              inspection with zero-gravity balancing.
            </p>
          </div>
        </div>
      </section>

      {/* Fixture Section */}
      <section className="service-section">
        <h2 className="service-title">Fixture</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          <div className="service-card">
            <img src={fximage1} alt="BIW CMM Checking Fixtures" />
            <h3 className="card-title">BIW CMM Checking Fixtures</h3>
            <p className="card-text">
              Precision-engineered solutions for accurate measurement and quality control of
              automotive body components.
            </p>
          </div>
          <div className="service-card">
            <img
              src={fximage2}
              alt="D-Pillar Glass / Head Lamp / Tail Lamp - Aperture Gauges"
            />
            <h3 className="card-title">
              D-Pillar Glass / Head Lamp / Tail Lamp - Aperture Gauges
            </h3>
            <p className="card-text">
              Specialized inspection tools for precise checking of apertures in automotive body
              components.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesContent;

